import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import CustomerDetails from '../../pages/CustomerDetails'
import Customers from '../../pages/Customers'

import MetaProvider from '../../providers/MetaProvider'
import EditProvider from '../../providers/EditProvider'
import CustomerProvider from '../../providers/CustomerProvider'

const CustomersRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:id`} component={CustomerDetails} />

      <Route
        path={path}
        render={() => (
          <MetaProvider>
            <EditProvider>
              <CustomerProvider>
                <Customers />
              </CustomerProvider>
            </EditProvider>
          </MetaProvider>
        )}
      />
    </Switch>
  )
}

export default CustomersRoute
